import { render, staticRenderFns } from "./position-list-by-id.vue?vue&type=template&id=632d1af5&scoped=true&"
import script from "./position-list-by-id.vue?vue&type=script&lang=js&"
export * from "./position-list-by-id.vue?vue&type=script&lang=js&"
import style0 from "./position-list-by-id.vue?vue&type=style&index=0&id=632d1af5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632d1af5",
  null
  
)

export default component.exports